import React from "react";

const AboutHome = () => {
  return (
    <section className="gauto-about-area section_70">
      <div className="container">
        <div className="row">
          
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="about-left">
              <h4>About Us</h4>
              <h2>Welcome to Shambhu Cabs</h2>
              <p>
                Shambhu Cabs is a trusted name in professional transportation,
                offering reliable, comfortable, and on-time cab services across
                Mumbai, Navi Mumbai, Thane and Maharashtra. With a strong focus on safety, customer
                satisfaction, and premium service standards, we ensure a smooth
                travel experience for every journey — corporate, airport, or
                outstation.
              </p>

              <div className="about-list">
                <ul>
                  <li><i className="fa fa-check"></i> Trusted and professional service</li>
                  <li><i className="fa fa-check"></i> Well-maintained fleet of all categories</li>
                  <li><i className="fa fa-check"></i> Experienced and courteous drivers</li>
                  <li><i className="fa fa-check"></i> Safe, comfortable & on-time travel</li>
                </ul>
              </div>

              {/* <div className="about-signature">
                <div className="signature-left">
                  <img src="/img/signature.png" alt="signature" />
                </div>
                <div className="signature-right">
                  <h3>Shambhu Cabs Team</h3>
                  <p>Committed to Excellence</p>
                </div>
              </div> */}
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-6">
            <div className="about-right">
              <img src="/img/about.png" alt="Shambhu Cabs" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHome;